import React from "react";

const STATUS_MAP = {
  OPN: { label: "Open", color: "primary" },
  INP: { label: "In Progress", color: "warning" },
  CRS: { label: "Resolved", color: "success" },
  CNR: { label: "Cancelled", color: "danger" },
  INV: { label: "Invoiced", color: "info" },
  NIV: { label: "Not Invoiced", color: "warning" },
};

export const getStatusMeta = (status) => {
  const normalized = String(status || "").toUpperCase();
  return STATUS_MAP[normalized] || {
    label: normalized || "No Status",
    color: "secondary",
  };
};

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatAuditDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const getActivityStatusLabel = (activity) => {
  const status = String(activity?.status || "").toUpperCase();
  return (
    STATUS_MAP[status]?.label ||
    "No Status"
  );
};

export default function ActivityTimeline({ activities = [] }) {
  if (!Array.isArray(activities) || activities.length === 0) {
    return (
      <div className="text-center text-muted border rounded-3 bg-light p-4">
        No activity found for this inquiry.
      </div>
    );
  }

  return (
    <div className="activity-timeline position-relative">
      {activities.map((activity, index) => {
        const status = String(activity?.status || "").toUpperCase();
        const statusMeta = getStatusMeta(status);
        const createdAt = activity?.created_at ?? activity?.createdAt;
        const followupDate = activity?.followup_date ?? activity?.followupDate;
        const createdByName = activity?.created_by_name || "System";
        const remark = activity?.remark ?? "-";
        const statusLabel = getActivityStatusLabel(activity);

        return (
          <div key={activity?.id ?? `${status}-${index}`} className="activity-item position-relative ps-4 pb-3">
            <span className="activity-dot position-absolute top-0 start-0 translate-middle-x rounded-circle bg-primary" />

            <div className="activity-card p-3 rounded-lg border bg-white shadow-sm">
              <div className="d-flex justify-content-between align-items-center">
                <span className={`badge bg-${statusMeta.color}`}>{statusLabel}</span>
                <span className="text-xs text-gray-400">{formatAuditDate(createdAt)}</span>
              </div>

              <p className="mt-1 text-sm text-gray-800 mb-0">
                {remark}
              </p>

              <div className="d-flex justify-content-between text-xs text-gray-500 mt-1 flex-wrap gap-2">
                <span>Added by {createdByName}</span>
                {followupDate ? (
                  <span>Follow-up: {formatDate(followupDate)}</span>
                ) : null}
              </div>
            </div>
          </div>
        );
      })}

      <style>{`
        .activity-timeline::before{
          content:"";
          position:absolute;
          top:0;
          bottom:0;
          left:8px;
          width:2px;
          background:linear-gradient(to bottom,rgba(13,110,253,.45),rgba(13,110,253,.08));
        }
        .activity-item:last-child{padding-bottom:0!important}
        .activity-dot{
          width:14px;
          height:14px;
          margin-top:10px;
          background:#0d6efd;
          box-shadow:0 0 0 4px rgba(13,110,253,.12);
          z-index:1;
        }
        .activity-card{
          margin-left:8px;
          border-radius:14px;
          background:#fff;
        }
        @media (max-width:575.98px){
          .activity-timeline::before{left:7px}
          .activity-card{margin-left:7px}
        }
      `}</style>
    </div>
  );
}
